import { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useUnit } from 'effector-react';
import { $authInfo, $isAuthInitialized } from '~/entities/auth';
import { routes } from '~/shared/constants/routes';
import { AppLoader } from '../AppLoader';
import { AppShell, type AppShellProps, WatchersProvider } from './components';
import '~/entities/payout';

type AppLayoutProps = AppShellProps;

export const AppLayout: FC<AppLayoutProps> = ({ variant = 'app', ...props }) => {
    const { pathname } = useLocation();

    const isPublic = variant === 'public';
    const isAuthRoute = pathname === routes.login || pathname === routes.registration || pathname === routes.recover;

    const {
        0: { isAuthenticated },
        1: isAuthInitialized,
    } = useUnit([$authInfo, $isAuthInitialized]);

    if (!isPublic && !isAuthInitialized) {
        return <AppLoader />;
    }

    if (!isPublic && !isAuthenticated && !isAuthRoute) {
        return (
            <Navigate
                to={routes.login}
                replace
            />
        );
    }

    if (isPublic) {
        return (
            <AppShell
                variant={variant}
                {...props}
            />
        );
    }

    return (
        <WatchersProvider>
            <AppShell
                variant={variant}
                {...props}
            />
        </WatchersProvider>
    );
};
